/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_CreateInputs */

const en_case_create = /** @type {(inputs: Case_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create case`)
};

const pt_br2_case_create = /** @type {(inputs: Case_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar caso`)
};

/**
* | output |
* | --- |
* | "Create case" |
*
* @param {Case_CreateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create = /** @type {((inputs?: Case_CreateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_CreateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create(inputs)
	return pt_br2_case_create(inputs)
});